import {PersonCredit} from './title';

export const PERSON_MODEL = 'person';

/**
 * Day 13 — AI-generated Turkish content (PersonIcerik).
 * Backend (Person::toArray) sadece durum='done' olunca doldurur, aksi
 * halde aiContent=null gelir. Internal field'lar (durum, ai_provider)
 * API yuzeyine sizmaz.
 */
export interface PersonAiContent {
  biyografi_tr: string;
  ilginc_bilgiler: Array<{title: string; content: string}>;
  faq: Array<{q: string; a: string}>;
  guncellenme: string;
  /** B26 (D35) — aktif locale biyografi (translation yoksa TR fallback). */
  biography?: string | null;
  /** B26 — aktif locale ilginç bilgiler (TR fallback). */
  interesting_facts?: Array<{title: string; content: string}>;
  /** B26 — aktif locale FAQ (TR fallback). */
  localized_faq?: Array<{q: string; a: string}>;
}

export interface Person {
  id: number;
  slug?: string;
  name: string;
  poster?: string;
  known_for?: string;
  gender?: string;
  birth_date: string;
  death_date: string;
  birth_place: string;
  primary_credit?: PersonCredit;
  views?: number;
  popularity?: number;
  updated_at?: string;
  description: string;
  model_type: typeof PERSON_MODEL;
  aiContent?: PersonAiContent | null;
  /** P5-C AR/RU — aktif locale'in script-özel takma adları (person_translations.
   * also_known_as; `people:sync-aka` job'ı doldurur, backend cast/crew payload'una
   * per-request ekler). AR/RU metinde bu adlarla kişi sayfasına inline link. */
  aka?: string[];
  /** Konu 4 — kalıcı Latin karşılığı (people.latin_name). Non-Latin adlı
   * kişilerde dolu olur; asla doğrudan okuma, `getPersonDisplayName()` kullan
   * (LATIN_NAME_DISPLAY_ENABLED bayrağını o yorumlar). */
  latin_name?: string | null;
  /** Konu 4 (FAZ 4) — editör bu alanı elle düzelttiyse true; otomatik doldurma
   * bir daha ezmez. Yalnız admin panelinde okunur. */
  latin_name_is_manual?: boolean;
}
